// Identificador de afinidade de sessão para o track-tiles-service.
//
// O balanceador (HAProxy) roteia por consistent-hash do query param `aff`, de modo
// que todas as requisições que carreguem o mesmo `aff` caem sempre na mesma réplica.
// Isso garante que o POST que cria o estado (getMbtilesTrack/getMbtilesRaster) e as
// requisições seguintes (tiles, operationColors, keepAlive) sejam atendidos pela
// mesma instância — sem depender de cookies.
//
// Granularidade: um id por aba/sessão do navegador (persistido em sessionStorage),
// estável entre reloads da mesma aba.

const STORAGE_KEY = 'tt_aff';

function generateUuid() {
    if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }
    // Fallback para navegadores sem crypto.randomUUID.
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
        const random = (Math.random() * 16) | 0;
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
}

let cachedId = null;

export function getAffinityId() {
    if (cachedId) {
        return cachedId;
    }
    try {
        cachedId = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
        cachedId = null;
    }
    if (!cachedId) {
        cachedId = generateUuid();
        try {
            sessionStorage.setItem(STORAGE_KEY, cachedId);
        } catch (e) {
            // sessionStorage indisponível (modo privado etc.): segue só com o cache em memória.
        }
    }
    return cachedId;
}
